import config from '../config';

export default function searchRepositories(query) {
    return fetch(`${config.github.apiBaseURL}/search/repositories?q=${query}&sort=stars&order=desc`);
}